<template>
    <v-row justify="end" align="center">
        <v-col cols="auto">
            <v-btn to="/" text :disabled="lang === 'ko' ? true : false" class="v-btn--text-fit">KR</v-btn>
        </v-col>
        <v-col cols="auto" class="pa-0">
            <v-divider vertical class="white h-16px" style="opacity: 0.5" />
        </v-col>
        <v-col cols="auto">
            <v-btn to="/en" text :disabled="lang === 'en' ? true : false" class="v-btn--text-fit">EN</v-btn>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        lang: { type: String, default: "ko" },
    },
};
</script>

<style lang="scss" scoped>
.v-btn {
    &:not(.v-btn--disabled) {
        color: var(--v-grey-base) !important;
    }
}
</style>